import React, { useContext } from 'react'
import MapStore from "../map/entities/map.store";

export type IStore = ReturnType<typeof getStore>

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getStore () {
  return {
    map: new MapStore()
  }
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const initialStore = getStore()
export const StoreContext = React.createContext(initialStore)

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAppStore = () => useContext(StoreContext)
